import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=26cda836&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cda836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26cda836')) {
      api.createRecord('26cda836', component.options)
    } else {
      api.reload('26cda836', component.options)
    }
    module.hot.accept("./Integrations.vue?vue&type=template&id=26cda836&scoped=true&", function () {
      api.rerender('26cda836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/Integrations.vue"
export default component.exports